<template>
  <a-layout class="index">
    <a-layout-sider
      breakpoint="lg"
      v-model="collapsed"
      :trigger="null"
      collapsible
    >

      <div class="logo"  :style=" 'background: url(' + this.axios.defaults.baseURL + '/setting/getLogo' + ') no-repeat center' " />

      <a-menu theme="dark" mode="inline" :selectedKeys="[curContent]"  :open-keys="openKeys"  @select="pickNav"   @openChange="onOpenChange">
        <template v-for="obj in navData">
          <a-menu-item v-if="!$lodash.has(obj, 'children')" :key="obj.key" style="padding-left: 14px" class="gauge-menu">
            <i :class="'anticon wb-'+obj.key" />
            <span>{{obj.title}}</span>
          </a-menu-item>




          <a-sub-menu v-else :key="subMenuKey(obj.key)">
            <span   slot="title"><i :class="'anticon wb-'+obj.key" /><span>{{obj.title}}</span></span>
            <a-menu-item v-for="child in obj.children"  style="padding-left: 52px" :key="child.key" class="childLevel">
              <span>{{child.title}}</span>
            </a-menu-item>
          </a-sub-menu>


        </template>
      </a-menu>
      <div class="coll-btn">
        <a-tooltip placement="right">
          <template slot="title">
            <span>{{collapsed ? '展开侧导航' : '收缩侧导航'}}</span>
          </template>
          <i :class="collapsed ? 'table-unfold': 'table-fold' "  @click="collapsed = !collapsed"></i>
<!--          <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="collapsed = !collapsed" />-->
        </a-tooltip>
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-header >
        <a-breadcrumb separator=">">
          <!-- <a-breadcrumb-item><a @click="returnHome()"><a-icon type="environment" style="margin-right: 5px;" /><span>工作台</span></a></a-breadcrumb-item> -->
          <a-breadcrumb-item v-for="title in breadcrumbData" :key="title">
            {{title}}
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="system-btn">
          <p v-html=" this.noticeMsg"></p>



            <a-popover v-model="warningVisible" title="消息" trigger="click" :overlayStyle="{width:'20%'}" >
              <div slot="content">
                <div class="system-content" v-for="v in this.warnList" :key="v.id">
                  <img src="../assets/images/messageRobot.png" alt="">
                  <div>
                    <a-tooltip>
                      <template slot="title">
                        {{v.message== 'null' ? '暂无信息':v.message}}
                      </template>
                      <p>{{v.message== 'null' ? '暂无信息':v.message}}</p>
                    </a-tooltip>
                    <span>{{ v.createTime }}</span>
                  </div>
                </div>
                <a @click="viewAllMessage">查看所有消息>></a>

              </div>
              <div class="promptMesge" v-if="$IA('system:notice:findPage')">
                <i @click="infoTop5Open"></i>
              </div>
            </a-popover>

          <a-divider type="vertical" />
          <a-dropdown :trigger="['click']" overlayClassName="dropdown-box">

            <a-avatar class="ant-dropdown-icon"  style="color: #ffff; backgroundColor: #3373f2">
              {{$store.state.user.userInfo.nickName?$store.state.user.userInfo.nickName.slice(0,1):$store.state.user.userInfo.userName.slice(0,1)}}
            </a-avatar>
            <a-menu slot="overlay" @click="pickMenu">
              <a-menu-item key="editPwd">
<!--                <a-icon type="form" />-->
                <i class="table-edit"></i>
                <span>修改密码</span>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="about">
                <i class="table-circle"></i>
                <span>关于系统</span>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="logout">
                <i class="table-logout"></i>
                <span>退出系统</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <span>欢迎您，{{$store.state.user.userInfo.nickName?$store.state.user.userInfo.nickName:$store.state.user.userInfo.userName}}！</span>

        </div>
      </a-layout-header>
      <a-layout-content>
        <component :is="curContent"  @open="openPage" @close="closeTrigger"  :currencyData="SingleTriggenData"></component>
      </a-layout-content>
      <!-- <a-layout-footer style="textAlign: center">
        ©2018 WillingBot 睿筹君 版权所有
      </a-layout-footer> -->
    </a-layout>

    <!-- 系统菜单模态框 -->
    <a-modal
      centered
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="btnLoad"
      @ok="handleOk"
      destroyOnClose
      :maskClosable="false"
      @cancel="resetForm"
      :footer="modalTitle == '关于系统' ? null:undefined"
    >
      <a-form-model v-if="modalTitle=='修改密码'" layout="vertical" :model="editPwdForm"  ref="editPwdForm" :rules="editPwdFormRules">
        <a-form-model-item label="原密码" prop="oldPassword">
          <a-input-password v-model="editPwdForm.oldPassword" placeholder="请输入原始密码" />
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="password">
          <a-input-password v-model="editPwdForm.password" placeholder="请输入新密码" />
        </a-form-model-item>
        <a-form-model-item label="再次输入" prop="againPassword">
          <a-input-password v-model="editPwdForm.againPassword" placeholder="请再次输入新密码" />
        </a-form-model-item>
      </a-form-model>
      <div v-if="modalTitle == '关于系统'" class="system-about">
        <a-divider />
          <p>
            <label style="color:#8d8d8d;">当前版本</label>: <span>{{   this.versionData.systemVersion }}</span>
          </p>
          <a-divider />

          <p>
            <label style="font-size:14px;">更新内容：</label>
            <br>
            <span class="renew" v-html="this.versionData.systemUpdateLog">
            </span>
          </p>
      </div>
    </a-modal>
  </a-layout>
</template>
<script>
import {validateNewPass} from "@/utils/validate";
import store from "@/store";
import Login from "@/views/Login.vue";
export default {
  data(){
    return {
      btnLoad: false,
      warningLoad:true,
      collapsed: false,
      curContent: 'home',
      // 展开的栏目KEY
      openKeys:[],
      rootSubmenuKeys:['automation','system'],
      SingleTriggenData:'',
      navData: [
        {key: 'home', title: '工作台', resourceKey: 'system:index:getCount'},
        // {key: 'message', title: '消息'},
        {key: 'job', title: '作业管理', resourceKey: 'system:job:index'},
        {key: 'taskLog', title: '流程日志', resourceKey: 'system:index:jobLog'},
        {key: 'trigger', title: '触发器管理', resourceKey: 'system:schedule:index'},
        {key: 'asset', title: '资产管理', resourceKey: 'system:asset:index'},
        {key: 'queue', title: '队列管理', resourceKey: 'system:queue:index'},
        {key: 'computer', title: '计算机管理', resourceKey: 'system:machine:index'},
        {key: 'robot', title: '机器人管理', resourceKey: 'system:robot:index'},
        {key: 'environment', title: '环境管理', resourceKey: 'system:environment:index'},
        {key: 'task', title: '流程管理', resourceKey: 'system:process:index'},
        {key: 'package', title: '包管理', resourceKey: 'system:package:index'},

        {key: 'system', title: '系统管理', children: [
            {key: 'user', title: '用户管理', resourceKey: 'system:user:index'},
            {key: 'department', title: '部门管理', resourceKey: 'system:org:index'},
            {key: 'role', title: '角色管理', resourceKey: 'system:role:index'},
            {key: 'resource', title: '资源管理', resourceKey: 'system:resource:index'},
            {key: 'log', title: '审计日志', resourceKey: 'system:syslog:index'},
            {key: 'file', title: '文件管理', resourceKey: 'system:foldermanagement:index'},
            {key: 'auth', title: '应用授权', resourceKey: 'system:app:index'},
            {key: 'license', title: '许可证管理', resourceKey: 'system:license:index'},
            // {key: 'file', title: '文件上传', resourceKey: 'system:document:index'},
            {key: 'mistakeWeekday', title: '日历管理', resourceKey: 'system:calendar:index'},
            {key: 'sysSet', title: '系统配置', resourceKey: 'system:setting:index'},
          ]},
      ],
      // navData: [
      //   {key: 'home', title: '工作台'},
      //   // {key: 'message', title: '消息'},
      //   {key: 'automation', title: '自动化管理', children: [
      //     {key: 'computer', title: '计算机管理', resourceKey: 'system:machine:index'},
      //     {key: 'robot', title: '机器人管理', resourceKey: 'system:robot:index'},
      //     {key: 'environment', title: '环境管理', resourceKey: 'system:environment:index'},
      //     {key: 'task', title: '流程管理', resourceKey: 'system:process:index'},
      //     {key: 'package', title: '包管理', resourceKey: 'system:package:index'},
      //     {key: 'job', title: '作业管理', resourceKey: 'system:job:index'},
      //     {key: 'trigger', title: '触发器管理', resourceKey: 'system:schedule:index'},
      //     {key: 'asset', title: '资产管理', resourceKey: 'system:asset:index'},
      //     {key: 'queue', title: '队列管理', resourceKey: 'system:queue:index'},
      //   ]},
      //   {key: 'system', title: '系统管理', children: [
      //     {key: 'user', title: '用户管理', resourceKey: 'system:user:index'},
      //     {key: 'department', title: '部门管理', resourceKey: 'system:org:index'},
      //     {key: 'role', title: '角色管理', resourceKey: 'system:role:index'},
      //     {key: 'resource', title: '资源管理', resourceKey: 'system:resource:index'},
      //     {key: 'log', title: '日志管理', resourceKey: 'system:syslog:index'},
      //     {key: 'auth', title: '应用授权', resourceKey: 'system:app:index'},
      //     {key: 'license', title: '许可证管理', resourceKey: 'system:license:index'},
      //     // {key: 'file', title: '文件上传', resourceKey: 'system:document:index'},
      //     {key: 'mistakeWeekday', title: '非工作日管理', resourceKey: 'system:calendar:index'},
      //     {key: 'sysSet', title: '系统配置', resourceKey: 'system:setting:index'},
      //   ]},
      // ],
      breadcrumbData: [],
      // 系统菜单
      modalVisible: false,
      modalTitle: '',
      // 修改密码表单
      editPwdForm: {
        oldPassword: '',
        password: '',
        againPassword: '',
      },
      editPwdFormRules: {
        oldPassword: [{required: true, message: '原密码不能为空'}],
        password: [
          { required: true, message: "密码不能为空" },
          { validator: validateNewPass, trigger: "blur" },
        ],
        againPassword: [
          {validator: (rule, value, callback) => {
            if (value === '') {
              return callback(new Error('请再次输入新密码'));
            }
            if (value !== this.editPwdForm.password) {
              return callback(new Error('两次输入密码不一致!'));
            }
            callback();
          }, trigger: 'blur',required: true},
        ],
      },
      // 预警通知
      warningVisible: false,
      warnList:[],
      // 更新版本内容
      versionData:{},
      // 许可证内容
      noticeMsg:''
    }
  },
  components: {
    'home': ()=>import('../components/M_index.vue'),
    'computer': ()=>import('../components/M_computer.vue'),
    'robot': ()=>import('../components/M_robot.vue'),
    'environment': ()=>import('../components/M_environment.vue'),
    'task': ()=>import('../components/M_task.vue'),
    'package': ()=>import('../components/M_wrapConfig.vue'),
    'job': ()=>import('../components/M_job.vue'),
    'trigger': ()=>import('../components/M_trigger.vue'),
    'asset': ()=>import('../components/M_asset.vue'),
    'queue': ()=>import('../components/M_queue.vue'),
    'user': ()=>import('../components/M_user.vue'),
    'department': ()=>import('../components/M_department.vue'),
    'role': ()=>import('../components/M_role.vue'),
    'resource': ()=>import('../components/M_resource.vue'),
    'log': ()=>import('../components/M_log.vue'),
    'license': ()=>import('../components/M_permitConfig.vue'),
    'file': ()=>import('../components/M_file.vue'),
    'auth': ()=>import('../components/M_appAuth.vue'),
    'permit': ()=>import('../components/M_permit.vue'),
    'message': ()=>import('../components/M_message.vue'),
    'sysSet': ()=>import('../components/M_systemConfig.vue'),
    'mistakeWeekday': ()=>import('../components/M_mistakeWeekday.vue'),
    'triggerConfig': ()=>import('../components/M_triggerConfig.vue'),
    'taskLog': ()=>import('../components/M_taskLog.vue'),
  },
  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      console.log(latestOpenKey)

        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys;
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        }

    },
    subMenuKey(key){
      return key
    },
    // 查看所有消息
    viewAllMessage() {
      this.warningVisible = false;
      this.curContent = 'message'
      this.breadcrumbData = [  "工作台", "消息"]
    },
    // 打开信息Top5
    infoTop5Open(){
      if (this.warningLoad){
        this.getWarning()
      }

    },
    // 获取警示通知top5
    getWarning() {
      this.warningLoad = true
      this.axios
          .post("/notice/findPage")
          .then((res) => {
            this.warningLoad = true
            this.warnList = res.data.records.slice(0,5);
          })
          .catch((err) => {
            this.warningLoad = false
            console.log(err);
          });

    },
     // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '修改密码') {
        this.$refs.editPwdForm.resetFields()
      }
      this.modalVisible = false
    },
    // 选择导航
    pickNav(nav){
      this.$cookies.remove('triggerQuery' )
      this.breadcrumbData = []
      if (nav.item.parentMenu.eventKey!==undefined) {
        let tempPobj = this.$lodash.find(this.navData, {key:nav.item.parentMenu.eventKey})
        this.breadcrumbData.push(tempPobj.title)
        let tempObj = this.$lodash.find(tempPobj.children, {key:nav.key})
        this.breadcrumbData.push(tempObj.title)
      }
      this.curContent = nav.key
      this.SingleTriggenData  = ''
    },
    // 选择系统菜单
    pickMenu(menu){
      switch (menu.key) {
        case 'editPwd':
          this.modalTitle = '修改密码'

          this.modalVisible = true
          break;
        case 'logout':
          this.$confirm({
            title: '确定退出吗？',
            content: '* 此操作将注销登录状态.',
            okText: '确定',
            cancelText: '取消',
            onOk:()=> {
              this.axios.get('/logout').then((res)=>{
                if (res.code===200) {
                  this.$notification.success({message: '退出成功!'})
                  this.$store.commit('user/logout')
                  this.$router.push('/login')
                }
              }).catch((e)=>{
                console.log(e.message);
              })
            },
            onCancel() {
              // todo……
            },
          });
          break;
        case 'about':
          this.modalTitle = '关于系统'
          this.modalVisible = true
          break;
      }
    },
    // 系统信息  
    systemInfo(){
      this.axios.get('/common/findGlobalConfiguration')
        .then((res) => {
          if (res.code === 200) {
            this.versionData = res.data
            this.$cookies.set('uploadLibraryMaxFileSize',( Math.floor(res.data.uploadLibraryMaxFileSize ?  res.data.uploadLibraryMaxFileSize : 209715200 ) / 1024 / 1024) ,"1d",'/')
            this.$cookies.set('uploadPackageMaxFileSize',( Math.floor(res.data.uploadPackageMaxFileSize ?  res.data.uploadPackageMaxFileSize : 209715200 ) / 1024 / 1024),"1d",'/')
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    returnHome(){
      this.curContent='home'
      this.breadcrumbData=[] // 清空面包屑数据
    },
    handleOk() {
      this.$refs.editPwdForm.validate((valid) => {
        if (valid) {
          this.btnLoad = true
          let saveData = this.$lodash.cloneDeep(this.editPwdForm)
          saveData.password = saveData.password.trim()
          saveData.oldPassword = saveData.oldPassword.trim()
          for (let x in saveData) {
            saveData[x] = this.$encrypt.encrypt(saveData[x])
          }
          this.axios.post('/user/updatePassword', saveData)
          .then((res) => {
            this.btnLoad = false
            if (res.code === 200) {
              this.modalVisible = false
              this.$notification.success({ message: '修改成功!', description: '快去输入新密码重新登录吧~' })
              this.$store.commit('user/logout')
              this.$router.push('/login')
            }
          })
          .catch((err) => {
            this.btnLoad = false
            console.log(err);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    // 打开组件页面
    openPage(data,title){
      switch (title) {
        case 'license':
          this.curContent = 'permit'
          break;
        case '查看作业':
          this.curContent = 'job'
          console.log(12)
          break;
        case '触发器':
          this.curContent = 'triggerConfig'
          break;
        case '工作台':
          this.curContent = 'job'
          break;
      }

      if(data.isTrusted){
         data = ''
      }
      this.SingleTriggenData = data
      this.$cookies.set('SingleTriggenData',data,"1d",'/')
    },
    // 点击返回主页面
    closeTrigger(val){
       switch (val) {
        case '触发器':
          this.curContent = 'trigger'
          break;
        case 'license':
          this.curContent = 'license'
          break;
         case '工作台':
           this.curContent = 'home'
    }
   },
  },
  watch: {
    curContent(n, o) {
      this.$store.commit('common/updatePageInfo', {pageKey: n, pagePath: this.breadcrumbData, openedKeys: this.openKeys})
    }
  },
  beforeMount(){
    console.log(this.$store.state.user.userInfo)
    this.curContent = this.$store.state.common.pageKey
    this.breadcrumbData = this.$store.state.common.pagePath
    this.openKeys = this.$store.state.common.openedKeys
    // this.getWarning()
    // 更新许可证信息
    this.axios.post("/license/getLicenseState").then(({ data }) => {
      this.noticeMsg = data.noticeMsg
      this.$cookies.remove('licenseState')
      if (data.licenseState ) {
        // this.curContent = 'license'
        // this.breadcrumbData = [  "工作台", "许可证管理"]
        this.$cookies.set('licenseState',data.licenseState,"1d",'/')
        // license({modalVisible:true,closableReset:true});  // 许可证弹出框
      }else{
        this.$cookies.set('licenseState',data.licenseState,"1d",'/')
      }

    });

    // 获取账号策略
    this.axios
        .post("/getAccountPolicy")
        .then((res) => {
          if (res.code == 200) {
            this.$cookies.set('getAccountPolicy',JSON.stringify(res.data),"1d",'/')
            this.$store.commit('user/getAccountPolicyInfo')
          }
        })
        .catch((err) => {
          console.log(err);
        });

    this.systemInfo()
    // 根据权限过滤菜单
    this.navData = this.navData.filter((x)=>{
      if (x.key=='home') {
        return true
      }
      if (this.$lodash.has(x, 'children')) {
        x.children = x.children.filter((y)=>{
          return y.resourceKey?this.$IA(y.resourceKey):true
        })
        if (x.children.length>0) {
          return true
        }
        return false
      } else {
        return x.resourceKey?this.$IA(x.resourceKey):true
      }
    })
  },
};
</script>

<style lang="scss" scoped>
.index {
  .ant-layout-sider {

    .logo {
      height: 45px;
      margin: 14px 16px 5px 15px;
      background-size: contain !important;
    }

    .ant-menu-dark {
      height: calc(100vh - 105px);
      overflow: auto;


      // 一级导航激活 颜色和icon
     //.ant-menu-submenu-open{
     //     color: #3373F3 !important ;
     //    .ant-menu-submenu-title{
     //      .wb-automation { background: url('../assets/images/Automation_selected.png') no-repeat center; }
     //      .wb-system { background: url('../assets/images/System_selected.png') no-repeat center; }
     //    }
     // }

      // 默认一级导航 颜色和icon
      .ant-menu-submenu{
         color: #2A354E;
      }
     .ant-menu-submenu-vertical{
        padding-left: 3px;
      }
      ::v-deep .ant-menu-dark .ant-menu-item:last-child{
        margin-left: 20px;
      }
      .ant-menu-submenu .ant-menu-submenu-title:hover{
        .wb-automation { background: url('../assets/images/Automation_default.png') no-repeat center; }
        //.wb-system { background: url('../assets/images/System_default.png') no-repeat center; }
      }
      .ant-menu-item,
      .ant-menu-submenu-title {


        .anticon {
          width: 20px;
          height: 20px;
          // opacity: 0.7;
          transition: 0.5s;
          margin-bottom: -3px;
        }
        //&:hover,
          &.ant-menu-item-selected {


          .anticon {
            opacity: 1;
            transition: 0.5s;
          }
          .wb-home { background: url('../assets/images/worktop_selected.png') no-repeat center  ;}
          .wb-job { background: url('../assets/images/operations_mangement_selected.png') no-repeat center; }
          .wb-trigger { background: url('../assets/images/trigger_management_selected.png') no-repeat center; }
          .wb-asset { background: url('../assets/images/liabilities_management_selected.png') no-repeat center; }
          .wb-queue { background: url('../assets/images/queue_management_selected.png') no-repeat center; }
          .wb-computer { background: url('../assets/images/pc_management_selected.png') no-repeat center; }
          .wb-robot { background: url('../assets/images/robot_management_selected.png') no-repeat center; }
          .wb-environment { background: url('../assets/images/environment_management_selected.png') no-repeat center; }
          .wb-package { background: url('../assets/images/package_management_selected.png') no-repeat center; }
          .wb-task { background: url('../assets/images/process_mangement_selected.png') no-repeat center; }
          .wb-system { background: url('../assets/images/system_management_selected.png') no-repeat center; }
          .wb-taskLog{ background: url('../assets/images/process_log_selected.png') no-repeat center; }



          //.wb-automation { background: url('../assets/images/Automation_selected.png') no-repeat center; }
          //.wb-user { background: url('../assets/images/User_selected.png') no-repeat center; }
          //.wb-department { background: url('../assets/images/Department_selected.png') no-repeat center; }
          //.wb-role { background: url('../assets/images/Role_selected.png') no-repeat center; }
          //.wb-resource { background: url('../assets/images/Resources_selected.png') no-repeat center; }
          //.wb-log { background: url('../assets/images/Log_selected.png') no-repeat center; }
          //.wb-auth { background: url('../assets/images/application_selected.png') no-repeat center; }
          //.wb-license { background: url('../assets/images/License_selected.png') no-repeat center; }
          //.wb-file { background: url('../assets/images/Upload_selected.png') no-repeat center; }
          //.wb-mistakeWeekday { background: url('../assets/images/Noday_Selected.png') no-repeat center; }
          //.wb-sysSet{ background: url('../assets/images/Sys_Selected.png') no-repeat center; }
        }
        .wb-home { background: url('../assets/images/worktop_default.png') no-repeat center; }
        .wb-job { background: url('../assets/images/operations_mangement_default.png') no-repeat center; }
        .wb-trigger { background: url('../assets/images/trigger_management_default.png') no-repeat center; }
        .wb-asset { background: url('../assets/images/liabilities_management_default.png') no-repeat center; }
        .wb-queue { background: url('../assets/images/queue_management_default.png') no-repeat center; }
        .wb-computer { background: url('../assets/images/pc_management_default.png') no-repeat center; }
        .wb-robot { background: url('../assets/images/robot_management_default.png') no-repeat center; }
        .wb-environment { background: url('../assets/images/environment_management_default.png') no-repeat center; }
        .wb-package { background: url('../assets/images/package_management_default.png') no-repeat center; }
        .wb-task { background: url('../assets/images/process_mangement_default.png') no-repeat center; }
        .wb-system { background: url('../assets/images/system_management_default.png') no-repeat center; }
        .wb-taskLog{ background: url('../assets/images/process_log_default.png') no-repeat center; }






        //.wb-automation { background: url('../assets/images/Automation_default.png') no-repeat center; }
        //.wb-user { background: url('../assets/images/User_default.png') no-repeat center; }
        //.wb-department { background: url('../assets/images/Department_default.png') no-repeat center; }
        //.wb-role { background: url('../assets/images/Role_default.png') no-repeat center; }
        //.wb-resource { background: url('../assets/images/Resources_default.png') no-repeat center; }
        //.wb-log { background: url('../assets/images/Log_default.png') no-repeat center; }
        //.wb-auth { background: url('../assets/images/Auth_default.png') no-repeat center; }
        //.wb-license { background: url('../assets/images/License_default.png') no-repeat center; }
        //.wb-file { background: url('../assets/images/Upload_default.png') no-repeat center; }
        //.wb-mistakeWeekday { background: url('../assets/images/Noday_default.png') no-repeat center; }
        //.wb-sysSet{ background: url('../assets/images/Sys_default.png') no-repeat center; }
      }

      .ant-menu-submenu-selected .ant-menu-submenu-title .anticon ,
      .ant-menu-submenu-open .ant-menu-submenu-title .anticon {
        opacity: 1;
        transition: 0.5s;
      }
    }
    .coll-btn {
      height: 40px;
      line-height: 40px;
      border-top: 1px solid #d7dde4;
      text-align: right;
      padding: 0 10px;
      background: #ffffff;
      i {
        cursor: pointer;
        background-size: 18px;
        cursor: pointer;
      }
    }
  }
  .ant-layout-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    margin-bottom:7px;
    box-shadow: 0 1px 4px rgb(0,21,41,.08);
   ::v-deep .ant-dropdown-icon {
      margin-right: 10px;
      cursor: pointer;
      width: 28px;
      height: 28px;
      line-height: 28px;
    }
    .ant-breadcrumb{
      span:nth-child(2){
        color: #3373f3;
      }
    }
  }

  .system-btn{
    display: flex;
    align-items: center;
    p{
      padding-top: 15px;
    }
    .ant-divider{
      margin: 0 15px;
      height: 1.9emm'n'n'n'n'n'n'n'n'n'n'n'n'n'n'n'n'n'n;
    }
    .promptMesge{
      //margin: 0 5px;
      margin-right: -8px;
      height: 30px;
      i{
        cursor:pointer;
        background: url("../assets/images/notice.png") no-repeat;
        display: inline-block;
        background-size: 70%;
        width: 27px;
        height: 27px;
        line-height: 24px;
        margin-top: 5px;
      }
    }
  }
}

.system-content{
      display: flex;
      align-items: center;
      border-bottom: 1px #e3e8ee solid;
      padding: 13px;
   
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;

      }
      div{
        p{
          width: 315px;
          margin-bottom: 5px;
          color:#414141;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;  // 默认不换行；
        }
        span{
          color:#a0a0a0;
        }
     
      }
 
}
.system-content:nth-child(1){
  padding-top: 0px;
}
.anticon-issues-close{
  font-size: 13px !important;
}
.system-about{
  margin: 0px -20px;
  padding-bottom: 40px;
  .ant-divider{
    margin: 0px 0px 12px;
  }
    p{
      padding: 0 25px;
      font-size: 15px;
      font-weight: 600;
      span{
        color:#ffa644 ;
        padding-left: 5px;
        font-size: 16px;
      }
    }
    .renew{
        font-size: 14px;
        color: #414141;
        display: inline-block;
        margin-top: 15px;
      }
}
/* 垂直滚动条样式 */
/* 宽度 */
::-webkit-scrollbar {
  width: 5px;

}
/* 背景色 */
::-webkit-scrollbar-track {
    background-color: #ffff;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #d7dde4;
}

/* 水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 5px;
}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #ffff;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #d7dde4 ;
}



</style>